module.exports = __webpack_public_path__ + "img/icon-vtex.af219bb0.svg";